<script lang="ts" setup>
import type { TeleportProps } from 'vue';

import { provideMenuPortalContext } from './context';

const props = defineProps<TeleportProps>();

provideMenuPortalContext({ teleportProps: props });
</script>
<template>
  <slot />
</template>
